export default __webpack_public_path__ + "static/media/3.09141cef.jpg";